import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Twitter, Mail } from "lucide-react";
import { useContent, mediaUrl } from "../context/ContentContext";
import { NewsletterForm } from "./NewsletterForm";

export const Footer = () => {
  const c = useContent();
  const L = c.links || {};
  const email = c.artist?.bookingEmail || "";
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#030303] pt-20 pb-10 overflow-hidden">
      {c.media?.rhythmTexture && <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{ backgroundImage: `url(${mediaUrl(c.media.rhythmTexture)})`, backgroundSize: "cover" }} />}
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14">
          <div>
            <h2 className="font-display text-6xl sm:text-8xl leading-[0.85] text-white">MVN<br />NATION</h2>
            <p className="mt-6 max-w-md text-white/50 text-sm leading-relaxed">{c.footer?.tagline}</p>
            <div className="mt-8 flex items-center gap-4">
              {[{ Icon: Instagram, url: L.instagram, t: "instagram" }, { Icon: Facebook, url: L.facebook, t: "facebook" }, { Icon: Youtube, url: L.youtube, t: "youtube" }, { Icon: Twitter, url: L.twitter, t: "twitter" }].map(({ Icon, url, t }) => (
                <a key={t} href={url || "#"} target="_blank" rel="noreferrer" data-testid={`footer-social-${t}`}
                  className="h-11 w-11 grid place-items-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-amberwarm hover:text-amberwarm"><Icon size={18} /></a>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-amberwarm mb-4">Join the Movement</p>
            <NewsletterForm compact />
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col gap-6">
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/55">
            {(Array.isArray(c.footerNav) && c.footerNav.length ? c.footerNav : [
              { label: "About", to: "/about" }, { label: "Music", to: "/music" }, { label: "Videos", to: "/videos" },
              { label: "News", to: "/news" }, { label: "Events", to: "/events" }, { label: "MVN Nation", to: "/mvn-nation" },
              { label: "Press / EPK", to: "/epk" }, { label: "Booking", to: "/booking" }, { label: "Contact", to: "/contact" },
            ]).map((l) => (
              <Link key={l.to + l.label} to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`} className="hover:text-amberwarm transition-colors">{l.label}</Link>
            ))}
          </nav>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-5 text-sm text-white/45">
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              <span className="text-white/70">BLessJ Official Website</span>
              <a href={`mailto:${email}`} className="inline-flex items-center gap-2 hover:text-amberwarm transition-colors"><Mail size={14} /> {email}</a>
              <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-amberwarm transition-colors">Privacy Policy</Link>
              <Link to="/cookies" data-testid="footer-link-cookies" className="hover:text-amberwarm transition-colors">Cookie Policy</Link>
            </div>
            <p>© {new Date().getFullYear()} BLessJ / MVN NATION. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
